module.exports = __webpack_public_path__ + "static/media/empf design.9e1419fe.png";